import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { Course } from '@lyceo/shared/plan/util-models';
import { CourseActions } from './course.actions';
import { TaskModalActions } from '../task/task.actions';
import { PupilContextActions } from '@lyceo/shared/pupil-context/data-access';
import { AuthActions } from '@lyceo/shared/auth/data-access';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const COURSE_FEATURE_KEY: string = 'planCourse';

export interface CourseState extends EntityState<Course> {
  callState: CallState;
}

export const courseAdapter: EntityAdapter<Course> =
  createEntityAdapter<Course>();

export const initialCourseState: CourseState = courseAdapter.getInitialState({
  callState: LoadingState.INIT,
});

const reducer: ActionReducer<CourseState, Action> = createReducer(
  initialCourseState,
  on(
    AuthActions.logoutSuccess,
    PupilContextActions.setPupilContext,
    (): CourseState => initialCourseState,
  ),
  on(
    TaskModalActions.init,
    (state): CourseState => ({
      ...state,
      callState: LoadingState.LOADING,
    }),
  ),
  on(
    CourseActions.getAllSuccess,
    (state, action): CourseState =>
      courseAdapter.setAll(action.courses, {
        ...state,
        callState: LoadingState.LOADED,
      }),
  ),
  on(
    CourseActions.getAllFailure,
    (state, { error }): CourseState => ({
      ...state,
      callState: { errorMsg: error.message },
    }),
  ),
);

export function courseReducer(
  state: CourseState | undefined,
  action: Action,
): CourseState {
  return reducer(state, action);
}
